import { useState, useEffect } from "react";
import AdminTabs from "../adminTabs";
import { Tab, TabContent } from "./helpers";
import GetAPI from "../../APICalls/GetQuery";
import PutAPI from "../../APICalls/PutAPI";
import SubscriptionsList from "./subscriptionsList";
import SubscriptionDetails from "./subscriptionDetails";
import ConfirmPopupModal from "../../Admin/ChefVerification/ConfirmPopupModal";
import { ThreeCircles } from "react-loader-spinner";

const Subscription = () => {
  const [activeTab, setActiveTab] = useState("new");
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [selectedSubscription, setSelectedSubscription] = useState(null);
  const [chefs, setChefs] = useState([]);
  const [selectedChef, setSelectedChef] = useState(null);
  const [loading, setLoading] = useState(false);
  const [distance, setDistance] = useState(0);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [updatedOrderedItems, setUpdatedOrderedItems] = useState([]);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  let environment = process.env.REACT_APP_NODE_ENV;
  let subscriptionAPI, getChefsAPI, userAPI;
  if (environment.toUpperCase() === "PRODUCTION") {
    subscriptionAPI = process.env.REACT_APP_PROD_SUBSCRIPTION_API;
    getChefsAPI = process.env.REACT_APP_PROD_GETCHEFBYDIS;
    userAPI = process.env.REACT_APP_PROD_USERAPI;
  } else {
    subscriptionAPI = process.env.REACT_APP_DEV_SUBSCRIPTION_API;
    getChefsAPI = process.env.REACT_APP_DEV_GETCHEFBYDIS;
    userAPI = process.env.REACT_APP_DEV_USERAPI;
  }

  useEffect(() => {
      const API_URL = subscriptionAPI;
      const QUERY_PARAMS = { subscriptionStatus: activeTab.toUpperCase() }
    GetAPI(API_URL, QUERY_PARAMS)
      .then((response) => {
        if (response.data.statusCode === 200) {
          setSubscriptionData(response.data.body);
        } else {
          alert(
            `Unable to get ${activeTab} subscriptions. Please try again!!!`
          );
        }
      })
      .catch((e) => {
        console.error(e);
        alert(`Unable to get ${activeTab} subscriptions. Please try again!!!`);
      });
  }, [activeTab]);

  useEffect(() => {
    if (selectedSubscription !== null) {
      const API_URL = getChefsAPI;
      const QUERY_PARAMS = { lat: selectedSubscription.craverDetails.craverAddressCoordinates.lat, lng: selectedSubscription.craverDetails.craverAddressCoordinates.lng };
      const CUSTOM_HEADER = {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: `${process.env.REACT_APP_TOKEN}`,
      };
      GetAPI(API_URL, QUERY_PARAMS, CUSTOM_HEADER)
        .then((response) => {
          let set = new Set([]);
          response.data.forEach((item) => {
            set.add({
              value: item.chefID,
              label:
                item.chefName +
                " - " +
                item.chefDistance +
                " - " +
                item.kitchenStyle.toUpperCase(),
              isDisabled:
                item.isUserAvailable !== undefined
                  ? item.isUserAvailable.toUpperCase() === "TRUE"
                    ? false
                    : true
                  : false,
            });
          });
          setChefs(Array.from(set));
        })
        .catch((e) => {
          console.error(e);
          alert(`Unable to get all chefs. Please try again!!!`);
        });
    }
  }, [selectedSubscription]);

  const handleOnClick = (subscription) => {
    setSelectedSubscription(subscription);
  };

  const handleClose = () => {
    setSelectedChef(null);
    setSelectedSubscription(null);
  };

  const handleChefClick = (itemData) => {
    let distance = itemData?.label?.split("-")[1]?.trim();

    const API_URL = userAPI;
    const QUERY_PARAMS = { userID: itemData?.value };
    
    GetAPI(API_URL, QUERY_PARAMS)
      .then((res) => {
        setSelectedChef(res.data.body);
        setDistance(distance);
      })
      .catch((e) => {
        console.error(e);
        alert("Unable to get user details");
      });
  };

  const handleDismiss = () => {
    setShowConfirmPopup(false);
  };

  const handleAssignChef = () => {
    const dataToPut = {
      subscriptionID: selectedSubscription.subscriptionID,
      type: "CHEF_ASSIGNED",
      chefID: selectedChef.userID,
      chefName: selectedChef.userName,
      orderedItems: updatedOrderedItems,
      distance: distance,
    };

    PutAPI(subscriptionAPI, dataToPut)
      .then((response) => {
        setLoading(false);
        if(response.data.statusCode === 200){
          alert("Updated chef price sucessfully!!!");
          setShowConfirmPopup(false);
          setSelectedSubscription(null);
          setSelectedChef(null);
          window.location.reload();
        } else {
          alert("Unable to update chef price. Please try again later");
        }
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
        alert("Unable to update chef price. Please try again later");
      });
  };

  return (
      <AdminTabs >
      {loading && (
        <div className="spinnerContainer">
          <div className="spinner">
            <ThreeCircles
              color="blue"
              height={110}
              width={110}
              ariaLabel="three-circles-rotating"
            />
          </div>
        </div>
      )}
      {showConfirmPopup && (
        <ConfirmPopupModal
          heading={"Are you sure you want to assign " + selectedChef.userName}
          show={showConfirmPopup}
          handleConfirmPopup={handleAssignChef}
          handleDismiss={handleDismiss}
          buttonText={"Assign " + selectedChef.userName}
          hideBody={true}
        />
      )}
      <SubscriptionDetails
        selectedSubscription={selectedSubscription}
        chefs={chefs}
        selectedChef={selectedChef}
        updatedOrderedItems={updatedOrderedItems}
        setUpdatedOrderedItems={setUpdatedOrderedItems}
        setShowConfirmPopup={setShowConfirmPopup}
        handleChefClick={handleChefClick}
        onClose={handleClose}
      />
        <div classNameName="container">
          <ul className="nav nav-tabs my-2" id="myTab" role="tablist">
            <Tab
              tabId="pending"
              isActive={activeTab.toLowerCase() === "pending"}
              count={activeTab.toLowerCase() === "pending" && subscriptionData.length}
              handleTabClick={handleTabClick}
            />
            <Tab
              tabId="new"
              isActive={activeTab.toLowerCase() === "new"}
              count={activeTab.toLowerCase() === "new" && subscriptionData.length}
              handleTabClick={handleTabClick}
            />
            <Tab
              tabId="ongoing"
              isActive={activeTab.toLowerCase() === "ongoing"}
              count={activeTab.toLowerCase() === "ongoing" && subscriptionData.length}
              handleTabClick={handleTabClick}
            />
            <Tab
              tabId="expired"
              isActive={activeTab.toLowerCase() === "expired"}
              count={activeTab.toLowerCase() === "expired" && subscriptionData.length}
              handleTabClick={handleTabClick}
            />
          </ul>
          <div className="tab-content" id="myTabContent">
            <TabContent tabId="pending" isActive={activeTab.toLowerCase() === "pending"}>
              <SubscriptionsList
                listData={subscriptionData}
                handleOnClick={handleOnClick}
              />
            </TabContent>
            <TabContent tabId="new" isActive={activeTab.toLowerCase() === "new"}>
              <SubscriptionsList
                listData={subscriptionData}
                handleOnClick={handleOnClick}
              />
            </TabContent>
            <TabContent tabId="ongoing" isActive={activeTab.toLowerCase() === "ongoing"}>
              <SubscriptionsList
                listData={subscriptionData}
                handleOnClick={handleOnClick}
              />
            </TabContent>
            <TabContent tabId="expired" isActive={activeTab.toLowerCase() === "expired"}>
              <SubscriptionsList
                listData={subscriptionData}
                handleOnClick={handleOnClick}
              />
            </TabContent>
          </div>
        </div>
        </AdminTabs>
  );
};

export default Subscription;
